'use strict';

angular.module('shiftTraderApp')
  .controller('LoginCtrl', function ($scope, security, $log, Session, Registration, ServerUrls, $http, $stateParams, Angularytics, flash, $state) {
    $scope.saveEmail = false; // initialize this to false

    $scope.login = function (username, password) {
      if($scope.saveEmail &&
        $scope.emailLoadedFromStorage !== $scope.username) {
        Session.saveEmailForLogin($scope.username);
      }

      security.login(username, password)
          .then(function() {
            console.log('successful login');
            $state.go('home');
          }, function(response) {
            if (response.status === 401 ) {
              if (response.data.error === 'account_inactive_error') {
                $scope.status = 'accountInactive';
                flash.error = 'Login denied. Your account is currently inactive. Please contact your manager if you believe this is in error.';
              } else if (response.data.error === 'employee_activation_feature_not_enabled') {
                $scope.status = 'employeeActivationNotEnabled';
                flash.error = 'Your store is now on the Shift Agent Basic plan. Please contact your manager for your schedule.';
              } else {
                console.log('incorrect username or password');
                $scope.status = 'credFail';
                flash.error = 'Incorrect user or password';
              }
            } else if (response.status > 401 || response.status === 400) {
              console.log('server problems');
              flash.error = 'Sorry! Server issue...';
            } else {
              console.log('successful login');
              return $state.go('home');
            }
          });
    };
    $scope.selectedServer = ServerUrls.selectedServer;

//If email query parameter given, fill out the form!
    if (angular.isDefined($stateParams.email)) {
      $scope.username = $stateParams.email;
    } else if (!_.isUndefined(Session.getEmailForLogin())) {
      $scope.username = Session.getEmailForLogin();
      $scope.emailLoadedFromStorage = Session.getEmailForLogin();
      $scope.saveEmail = true;
    }

    $scope.sendResetPassword = function() {
      Angularytics.trackEvent('Session', 'Reset password');
      if ($scope.loginForm.loginEmail.$valid) {
        var data = {
          user: {
            email: $scope.username
          }
        };
        return $http.post(ServerUrls.current.railsApi + 'users/password.json', data)
            .then(function(response) {
              console.log('reset password sent');
              console.log(response);
              $scope.resetSent = true;
              flash.success = 'Password reset email sent. Please follow the link in your email.';
            }, function() {
              flash.error = 'Password reset failed. Please try again.';
            });
      } else {
        flash.error = 'Not a valid e-mail address for password reset. Please try again.';
      }
    };

    // if it ever gets cleared then clear the username from localStorage
    $scope.$watch('saveEmail', function(saveEmail) {
      if (!saveEmail) {
        Session.clearEmailForLogin();
      }
    });
  });
